import React,{useContext, useState} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { postRequest } from '../../api/ApiController';
import { InfoIcon, ErrorIcon, TaskIcon, PermissionIcon, EmergencyIcon, BuyItemIcon,BorrowItemIcon, TechChangeIcon} from "../svg/svgIcons";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { Checkbox } from "primereact/checkbox";
import { Accordion, AccordionTab } from 'primereact/accordion';
import '../../assets/css/support.css'
import parse from 'html-react-parser';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import MyEditor from '../../components/Editor';
import { InputSwitch } from 'primereact/inputswitch';
import { LocaleContext } from '../../components/LocaleContext';
import {
    appendServiceTaskSenderId,
    interpretServiceTaskCreateResponse,
    interpretServiceTaskCreateTransportError,
} from '../../utils/serviceTaskCreateHttp';
import { dispatchServiceTaskListInvalidated } from '../../utils/serviceTaskListSync';

export default function ServiceTaskAdd({service_task=null, type="add"}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {toast,setDialogText,setVisible}= useContext(UtilContext);
    const { t } = useContext(LocaleContext);

    const [closeTab] = useState(false);

    const [formServiceTask] = useState(service_task);
    const [activeIndex,setActiveIndex] = useState(null);

    const [recipients,setRecipients] = useState(state.employees?.filter(employee => employee.date_of_departure === null || employee.date_of_departure === ""));

    var foundIDs = [];

    function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }

    function loopThroughDOM(obj) {
        if(Array.isArray(obj)){
            for(let i=0;i<obj.length;i++){
                if(obj[i].hasOwnProperty("props") && obj[i].props.hasOwnProperty("children")){
                    loopThroughDOM(obj[i]["props"]["children"]);
                }
                if(obj[i].hasOwnProperty("props") && obj[i].props.hasOwnProperty("data-value")){
                    foundIDs.push(obj[i]["props"]["data-id"]);
                }
            }
        }
        else{
            if(obj.hasOwnProperty("props") && obj.props.hasOwnProperty("children") && obj.props.children !== undefined){
                loopThroughDOM(obj["props"]["children"]);
            }
            if(obj.hasOwnProperty("props") && obj.props.hasOwnProperty("data-value")){
                foundIDs.push(obj["props"]["data-id"]);
            }
        }
    }

    const validate = values => {
        const errors = {};
        if ((activeIndex === 1 || activeIndex === 5) && !values.machine_id) {
            errors.machine_id = t('Common.RequiredField');
        }
        return errors;
    };

    const formik = useFormik({
        initialValues: formServiceTask === null ? {
            theme:'',description:'',sending_option:'immediately',regularity:'',time_period:'',sending_date:'',sending_time:'',contractor_user:true,sender_id:user.id,machine_id:null,machine_state:'',
            recipientDepartments:[],recipients:[],email:true,sms:false
        }:formServiceTask,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            let formData = new FormData();
            for (let value in values) {
                if (value === "files") {
                    for(let i = 0;i<values[value].length;i++){
                        formData.append('files[]',values[value][i]);
                    }
                }
                else if (value === "recipientDepartments" || value === "recipients") {
                    console.log(value,values[value]);
                    formData.append(value, values[value]?.map(obj => obj.id));
                }
                else if(value !== "regularity" && value !== "time_period" && value !== "sender_id" && value !== "machine_id"){
                    formData.append(value, values[value] != null ? values[value] : "");
                }
            }
            var combined = {
                regularity: values.regularity,
                time_period: values.time_period,
                email: values.email,
                sms: values.sms
            }   
            formData.append("sending_data", JSON.stringify(combined));
            formData.append("contractor_id", user.id);
            appendServiceTaskSenderId(formData, user, values);
            formData.append("machine_id", values?.machine_id ? values?.machine_id?.id : "");
            if (activeIndex === 1 && values?.machine_state) {
                formData.append("machine_state", values.machine_state);
            }
            let mentions = parse(values.description);
            loopThroughDOM(mentions);
            foundIDs.push(user.id+'');
            formData.append('mentions', foundIDs.filter(onlyUnique));
            switch(activeIndex){
                case 0: {formData.append('type', 'Info');break;}
                case 1: {formData.append('type', 'Error');break;}
                case 2: {formData.append('type', 'Task');break;}
                case 3: {formData.append('type', 'TechChange');break;}
                case 4: {formData.append('type', 'Permission');break;}
                case 5: {formData.append('type', 'Need');break;}
                case 6: {formData.append('type', 'Borrow');break;}
                case 7: {formData.append('type', 'Emergency');break;}
                default: {formData.append('type', 'Info');break;}
            }
            const notify = (severity, summaryKey, detail) => {
                const summary = t(summaryKey);
                const text = detail || summary;
                if (toast?.current?.show) {
                    toast.current.show({ severity, summary, life: 4000, detail: text });
                    return;
                }
                alert(text);
            };
            postRequest('/api/service_tasks', formData,true)
            .then((response) => {
                const result = interpretServiceTaskCreateResponse(response);
                if (!result.ok) {
                    setVisible(false);
                    notify('error', result.messageKey, result.detail ? result.detail : t(result.messageKey));
                    return;
                }
                if(closeTab) dispatch({type:'close_tab',id:state.selectedTab});
                dispatchServiceTaskListInvalidated({ reason: 'create' });
                formik.resetForm();
                foundIDs = [];
                setActiveIndex(null);
                toast?.current?.show({ severity: 'info', summary: t('ServiceTask.Confirmed'), life: 3000, detail: t('ServiceTask.RecordSaved') });
                setVisible(false);
            }).catch(() => {
                setVisible(false);
                const result = interpretServiceTaskCreateTransportError(navigator.onLine);
                notify('error', result.messageKey, t(result.messageKey));
            });
      },
    });

    const weekTimePeriod = [
        {name: t('Common.Day.Monday')},
        {name: t('Common.Day.Tuesday')},
        {name: t('Common.Day.Wednesday')},
        {name: t('Common.Day.Thursday')},
        {name: t('Common.Day.Friday')},
        {name: t('Common.Day.Saturday')},
        {name: t('Common.Day.Sunday')},
    ];

    const service_types = {
        0: "Info",
        1: "Error",
        2: "Task",
        3: "TechChange",
        4: "Permission",
        5: "Need",
        6: "Borrow",
        7: "Emergency",
    };

    const monthTimePeriod = Array.from({length: 31}, (_, i) => i + 1).map((i) =>{
        return {name: ''+i};}
        
    )

    function filterRecipients(departments){
        formik.setFieldValue("recipientDepartments",departments);
        setRecipients(state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "")
        .filter(employee => departments.map(department => department.id).includes(parseInt(employee?.department_id))));
        if (departments.length === 0) {
            setRecipients(state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === ""));
            formik.setFieldValue("recipients",[])
        }
        else{
            formik.setFieldValue("recipients",state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").filter(employee => departments.map(department => department.id).includes(parseInt(employee?.department_id))).map((employee) => ({name:employee.name,id:employee.id,searchLabel: removeDiacritics(employee.name).toLowerCase()})));
        }
    }

    function checkSender(value){
        formik.setFieldValue("contractor_user",value);
        if(value)formik.setFieldValue("sender_id",user?.employee?.id);
    }

    function checkIndexPermission(index) {
        let levels = state.service_levels?.filter(level => level?.type === service_types[index] && level?.task === "creation");
        if (levels?.length === 0) return true;
        let level = levels[0];
        let settings = state.service_user_settings.filter(setting => Number(setting.level_id) === Number(level.id));
        if (settings?.length === 0) return true;
        for (let setting of settings) {
            if (setting?.user_id != null) {
                if (Number(setting?.user_id) === Number(user?.id)) return true;
            } else {
                if (Number(setting?.department_id) === Number(user?.employee?.department_id)) return true;
            }
        }
        return false;
    }

    function removeDiacritics(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return (
        <>
        <form onSubmit={formik.handleSubmit}>
        <div className="w-full relative flex flex-col overflow-x h-[calc(100vh_-_137px)]">
            <div className='w-full px-4 py-4 bg-[#333] text-white border rounded-sm'>
                <h1 className='text-left text-3xl font-semibold'>{t('ServiceTaskAdd')}</h1>
            </div>
            <div className='card flex flex-col px-4 py-4 border rounded-sm shadow-xl overflow-y-auto'>
            <Accordion activeIndex={activeIndex} onTabChange={(e) => {setActiveIndex(e.index);formik.resetForm();}}>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 0) ? "hidden" : ""}`} disabled={!checkIndexPermission(0)}
                header={<React.Fragment><InfoIcon width={10} height={10}/><span>{t('ServiceTask.Type.Info')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.InfoIntro')}</p>
                            <p className='mb-2'>{t('ServiceTaskAdd.Thanks')}</p>
                        <div className='mb-3'>
                            <label className='font-semibold text-md'>{t('ServiceTaskAdd.InfoName')}</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-3'>
                        <label className='font-semibold  text-md'>{t('ServiceTaskAdd.InfoDescription')}</label>
                        {/*<Editor modules={modules} name='description' value={formik.values.description} onTextChange={(e) => {formik.setFieldValue('description',e.htmlValue);}} style={{ height: '180px' }} />*/}
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        {t('ServiceTaskAdd.AttachmentCount')}: {}<br/>
                        </div>
                        <div className='mb-3'>
                        <label className='font-semibold  text-md'>{t('ServiceTaskDetail.SendingTimeSetup')}</label>
                        <div className='mb-3'>
                        <select 
                        name="sending_option"
                        value={formik.values.sending_option}
                        onChange={(e) => {formik.setFieldValue("sending_option",e.target.value)}}
                        className='bg-white block w-full  px-4 py-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="immediately">{t('ServiceTaskDetail.AfterApproval')}</option>
                            <option value="once">{t('ServiceTaskDetail.SetDateTime')}</option>
                            <option value="repeat">{t('ServiceTaskDetail.Repeat')}</option>
                        </select>
                        </div>
                        {formik.values.sending_option === "once" &&<div className='mb-3'>
                        <label className='font-semibold text-sm'>{t('ServiceTaskDetail.SendingDate')}</label>
                        <input
                            name='sending_date'
                            type="date"
                            required
                            onChange={formik.handleChange} value={formik.values.sending_date}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        <label
                            for="sending_time"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.SendingTime')}
                        </label>
                        <input
                            name='sending_time'
                            type="time"
                            min="05:00" max="22:00"
                            required
                            onChange={formik.handleChange} value={formik.values.sending_time}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>}
                        {formik.values.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="regularity"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Schedule')}
                        </label>
                        <select 
                        name='regularity' required
                        onChange={(e) => {formik.setFieldValue("regularity",e.target.value);formik.setFieldValue("time_period",[]);}} value={formik.values.regularity}
                        className={`bg-white block w-full  px-4 py-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Common.SelectOption')}</option>
                          <option value="Denne">{t('ServiceTaskDetail.Daily')}</option>
                          <option value="Týždenne">{t('ServiceTaskDetail.Weekly')}</option>
                          <option value="Mesačne">{t('ServiceTaskDetail.Monthly')}</option>
                        </select>
                        </div>}
                        {formik.values.regularity === 'Mesačne' && formik.values.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="time_period"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Regularity')}
                        </label>
                        <MultiSelect required value={formik.values.time_period} onChange={(e) => formik.setFieldValue("time_period",e.value)} options={monthTimePeriod} optionLabel="name"
                            filter placeholder={t('ServiceTaskDetail.SelectRegularity')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>}
                        {formik.values.regularity === 'Týždenne' && formik.values.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="time_period"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Regularity')}
                        </label>
                        <MultiSelect required value={formik.values.time_period} onChange={(e) => formik.setFieldValue("time_period",e.value)} options={weekTimePeriod} optionLabel="name"
                            filter placeholder={t('ServiceTaskDetail.SelectRegularity')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>}
                        {formik.values.sending_option === "repeat" && <div>
                        <label
                            for="sending_time"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.SendingTime')}
                        </label>
                        <input
                            name='sending_time'
                            type="time"
                            min="05:00" max="22:00"
                            required
                            onChange={formik.handleChange} value={formik.values.sending_time}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>}
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.WhoSendsInfo')}</label>
                            {user?.employee != null && <div className='mb-2'><Checkbox onChange={e => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className='text-sm'>{t('ServiceTaskAdd.SameAsRequester')}</label></div>}
                            {(formik.values.contractor_user === false || user?.employee === null)&& <div>
                            <Dropdown required value={formik.values.sender_id} onChange={(e) => formik.setFieldValue("sender_id",e.value)} 
                            options={state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").map((employee) => 
                                ({name:employee?.name,id:employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployee')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            </div>}
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.InfoRecipients')}</label>
                        <div>
                        <label
                            htmlFor="recipientDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('Common.Department')}
                        </label>
                        <MultiSelect onChange={(e) => filterRecipients(e.target.value)} value={formik.values.recipientDepartments} 
                            options={state.departments.map((department) => 
                                ({name:department.name,id:department.id})
                            )} 
                            optionLabel="name"
                            filter placeholder={t('ServiceTaskDetail.SelectDepartments')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div>
                        <label
                            htmlFor="recipients"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('Common.Employee')}
                        </label>
                        <MultiSelect value={formik.values.recipients} onChange={(e) => formik.setFieldValue("recipients",e.value)} 
                            options={recipients.map((employee) => 
                                ({name:employee.name,id:employee.id,searchLabel: removeDiacritics(employee.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployees')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className="flex justify-content-center mb-2 mt-2">
                            <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Common.Email')}:</label>
                            <InputSwitch checked={formik.values.email} onChange={(e) => formik.setFieldValue("email",e.value)} />
                        </div>
                        <div className="flex justify-content-center">
                            <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Common.SMS')}:</label>
                            <InputSwitch checked={formik.values.sms} onChange={(e) => formik.setFieldValue("sms",e.value)} />
                        </div>
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 1) ? "hidden" : ""}`} disabled={!checkIndexPermission(1)}
                header={<React.Fragment><ErrorIcon width={10} height={10}/><span>{t('ServiceTaskAdd.ReportError')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.ErrorIntro')}<br/>
                           {t('ServiceTaskAdd.ErrorDetails')}<br/>
                           {t('ServiceTaskAdd.ErrorArchived')}
                        </p>
                            <p className='mb-2'>{t('ServiceTaskAdd.Thanks')}</p>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskAdd.ErrorName')}:</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                        <label className='font-semibold  text-sm'>{t('ServiceTaskAdd.ErrorDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.WhoReportsError')}:</label>
                            <div className='mb-2'><Checkbox onChange={e => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className='text-sm'>{t('ServiceTaskAdd.SameAsRequester')}</label></div>
                            {formik.values.contractor_user === false && <div>
                            <Dropdown required value={formik.values.sender_id} onChange={(e) => formik.setFieldValue("sender_id",e.value)} 
                            options={state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").map((employee) => 
                                ({name:employee?.name,id:employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployee')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            </div>}
                        </div>
                        <div className='mb-2'>
                            <label className='font-semibold  text-sm'>{t('Common.Machine')}:</label>
                            <Dropdown required value={formik.values.machine_id} onChange={(e) => formik.setFieldValue("machine_id",e.value)} 
                            options={state.machines.map((machine) => 
                                ({name:machine?.name,id:machine.id,searchLabel: removeDiacritics(machine?.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectMachine')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            {formik.errors.machine_id && (
                                <small className="p-error">{formik.errors.machine_id}</small>
                            )}
                        </div>
                        <div className='mb-2'>
                            <label className='font-semibold  text-sm'>{t('ServiceTask.MachineState')}:</label>
                            <Dropdown value={formik.values.machine_state} onChange={(e) => formik.setFieldValue("machine_state",e.value)} 
                            options={[
                                {value: 'in_fault', label: t('ServiceTask.MachineState.InFault')},
                                {value: 'working_limited', label: t('ServiceTask.MachineState.WorkingLimited')},
                                {value: 'functional', label: t('ServiceTask.MachineState.Functional')},
                            ]} 
                            optionLabel="label"
                            optionValue="value"
                            placeholder={t('ServiceStateAdd.SelectStateType')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 2) ? "hidden" : ""}`} disabled={!checkIndexPermission(2)}
                header={<React.Fragment><TaskIcon width={10} height={10}/><span>{t('ServiceTaskAdd.AssignTask')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.TaskIntro')}<br/>
                           {t('ServiceTaskAdd.TaskDetails')}<br/>
                           {t('ServiceTaskAdd.TaskNotifications')}
                        </p>
                            <p className='mb-2'>{t('ServiceTaskAdd.Thanks')}</p>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskAdd.TaskName')}:</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                        <label className='font-semibold  text-sm'>{t('ServiceTaskAdd.TaskDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.WhoRequestsTask')}:</label>
                            <div className='mb-2'><Checkbox onChange={e => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className='text-sm'>{t('ServiceTaskAdd.SameAsRequester')}</label></div>
                            {formik.values.contractor_user === false && <div>
                             <Dropdown required value={formik.values.sender_id} onChange={(e) => formik.setFieldValue("sender_id",e.value)} 
                            options={state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").map((employee) => 
                                ({name:employee?.name,id:employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase()})
                            )}
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployee')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            </div>}
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
                <AccordionTab
                    className={`${(activeIndex !== null && activeIndex !== 3) ? "hidden" : ""}`} disabled={!checkIndexPermission(3)}
                    header={<React.Fragment><TechChangeIcon width={10} height={10} /><span>{t('ServiceTaskAdd.TechChangeRequest')}</span></React.Fragment>}
                >
                    <p>{t('ServiceTaskAdd.TechChangeIntro')}<br />
                       {t('ServiceTaskAdd.TechChangeDetails')}<br />
                       {t('ServiceTaskAdd.TechChangeNotifications')}
                    </p>
                    <p className="mb-2">{t('ServiceTaskAdd.Thanks')}</p>
                    <div className="mb-2">
                        <label className="font-semibold text-sm">{t('ServiceTaskAdd.TechChangeName')}:</label>
                        <input name="theme" required
                        value={formik.values.theme}
                        onChange={formik.handleChange}
                        className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                    </div>

                    <div className="mb-2">
                        <label className="font-semibold text-sm">{t('ServiceTaskAdd.TechChangeDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                    </div>

                    <div className="mb-3">
                        <label className="font-semibold text-md">{t('ServiceTaskAdd.WhoRequestsTechChange')}:</label>
                        <div className="mb-2">
                            <Checkbox onChange={(e) => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className="text-sm">{t('ServiceTaskAdd.SameAsRequester')}</label>
                    </div>

                        {formik.values.contractor_user === false && (
                        <div>
                            <Dropdown
                            required
                            value={formik.values.sender_id}
                            onChange={(e) => formik.setFieldValue("sender_id", e.value)}
                            options={state.employees
                                .filter((employee) => employee.date_of_departure === null || employee.date_of_departure === "")
                                .map((employee) => ({ name: employee?.name,id: employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase(),}))}
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')}
                            placeholder={t('ServiceTaskDetail.SelectEmployee')}
                            className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                        </div>
                        )}
                    </div>

                    <button type="submit" className="flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25">{t('Common.Save')}</button>
                </AccordionTab>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 4) ? "hidden" : ""}`} disabled={!checkIndexPermission(4)}
                header={<React.Fragment><PermissionIcon width={10} height={10}/><span>{t('ServiceTaskAdd.PermissionRequest')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.PermissionIntro')}<br/>
                           {t('ServiceTaskAdd.PermissionDetails')}<br/>
                           {t('ServiceTaskAdd.PermissionNotifications')}
                        </p>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskAdd.PermissionName')}:</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                        <label className='font-semibold  text-sm'>{t('ServiceTaskAdd.PermissionDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.WhoRequestsPermission')}:</label>
                            <div className='mb-2'><Checkbox onChange={e => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className='text-sm'>{t('ServiceTaskAdd.SameAsRequester')}</label></div>
                            {formik.values.contractor_user === false && <div>
                             <Dropdown required value={formik.values.sender_id} onChange={(e) => formik.setFieldValue("sender_id",e.value)} 
                            options={state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").map((employee) => 
                                ({name:employee?.name,id:employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase()})
                            )}
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployee')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            </div>}
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 5) ? "hidden" : ""}`}  disabled={!checkIndexPermission(5)}
                header={<React.Fragment><BuyItemIcon width={10} height={10}/><span>{t('ServiceTaskAdd.PurchaseRequest')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.PurchaseIntro')}<br/>
                           {t('ServiceTaskAdd.PurchaseDetails')}<br/>
                           {t('ServiceTaskAdd.PurchaseNotifications')}
                        </p>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskAdd.PurchaseName')}:</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                        <label className='font-semibold  text-sm'>{t('ServiceTaskAdd.PurchaseDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.WhoRequestsPurchase')}:</label>
                            <div className='mb-2'><Checkbox onChange={e => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className='text-sm'>{t('ServiceTaskAdd.SameAsRequester')}</label></div>
                            {formik.values.contractor_user === false && <div>
                             <Dropdown required value={formik.values.sender_id} onChange={(e) => formik.setFieldValue("sender_id",e.value)} 
                            options={state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").map((employee) => 
                                ({name:employee?.name,id:employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployee')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            </div>}
                        </div>
                        <div className='mb-2'>
                            <label className='font-semibold  text-sm'>{t('Common.Machine')}:</label>
                            <Dropdown required value={formik.values.machine_id} onChange={(e) => formik.setFieldValue("machine_id",e.value)} 
                            options={state.machines.map((machine) => 
                                ({name:machine?.name,id:machine.id,searchLabel: removeDiacritics(machine?.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectMachine')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            {formik.errors.machine_id && (
                                <small className="p-error">{formik.errors.machine_id}</small>
                            )}
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 6) ? "hidden" : ""}`}  disabled={!checkIndexPermission(6)}
                header={<React.Fragment><BorrowItemIcon width={10} height={10}/><span>{t('ServiceTaskAdd.BorrowRequest')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.BorrowIntro')}<br/>
                           {t('ServiceTaskAdd.BorrowDetails')}<br/>
                           {t('ServiceTaskAdd.BorrowNotifications')}
                        </p>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskAdd.BorrowName')}:</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                        <label className='font-semibold  text-sm'>{t('ServiceTaskAdd.BorrowDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        </div>
                        <div className='mb-3'>
                            <label className='font-semibold  text-md'>{t('ServiceTaskAdd.WhoRequestsBorrow')}:</label>
                            <div className='mb-2'><Checkbox onChange={e => checkSender(e.checked)} checked={formik.values.contractor_user} className="p-button-sm p-button-text mr-1"/>
                            <label className='text-sm'>{t('ServiceTaskAdd.SameAsRequester')}</label></div>
                            {formik.values.contractor_user === false && <div>
                             <Dropdown required value={formik.values.sender_id} onChange={(e) => formik.setFieldValue("sender_id",e.value)} 
                            options={state.employees.filter(employee => employee.date_of_departure === null || employee.date_of_departure === "").map((employee) => 
                                ({name:employee?.name,id:employee.id,searchLabel: removeDiacritics(employee?.name).toLowerCase()})
                            )} 
                            optionLabel="name"
                            filter
                            filterBy="searchLabel"
                            filterMatchMode="contains"
                            filterPlaceholder={t('Common.Search')} placeholder={t('ServiceTaskDetail.SelectEmployee')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                            </div>}
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
                <AccordionTab className={` ${(activeIndex !== null && activeIndex !== 7) ? "hidden" : ""}`} disabled={!checkIndexPermission(7)}
                header={<React.Fragment><EmergencyIcon width={10} height={10}/><span>{t('ServiceTaskAdd.EmergencyMessage')}</span></React.Fragment>}>
                        <p>{t('ServiceTaskAdd.EmergencyIntro')}<br/>
                           {t('ServiceTaskAdd.EmergencyWarning')}<br/>
                        </p>
                        <div className='mb-2'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskAdd.EmergencyName')}:</label>
                            <input name='theme' required value={formik.values.theme} onChange={formik.handleChange} className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div className='mb-2'>
                        <label className='font-semibold  text-sm'>{t('ServiceTaskAdd.EmergencyDescription')}:</label>
                        <MyEditor editorValue={formik.values.description} fileAccept="*" formik={formik} />
                        </div>
                        <div className='mb-3'>
                        <label className='font-semibold  text-md'>{t('ServiceTaskDetail.SendingTimeSetup')}</label>
                        <div className='mb-3'>
                        <select 
                        name="sending_option"
                        value={formik.values.sending_option}
                        onChange={(e) => {formik.setFieldValue("sending_option",e.target.value)}}
                        className='bg-white block w-full  px-4 py-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="immediately">{t('ServiceTaskDetail.SendImmediately')}</option>
                            <option value="once">{t('ServiceTaskDetail.SetDateTime')}</option>
                        </select>
                        </div>
                        {formik.values.sending_option === "once" &&<div className='mb-3'>
                            <label className='font-semibold text-sm'>{t('ServiceTaskDetail.SendingDate')}</label>
                        <input
                            name='sending_date'
                            type="date"
                            required
                            onChange={formik.handleChange} value={formik.values.sending_date}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        <label
                            for="sending_time"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.SendingTime')}
                        </label>
                        <input
                            name='sending_time'
                            type="time"
                            min="05:00" max="22:00"
                            required
                            onChange={formik.handleChange} value={formik.values.sending_time}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>}
                        {formik.values.regularity === 'Týždenne' && formik.values.sending_option === "repeat" && <div className='mb-3'>
                        <label
                            htmlFor="time_period"
                            className="block text-sm font-semibold text-gray-800"
                        >
                            {t('ServiceTaskDetail.Regularity')}
                        </label>
                        <MultiSelect required value={formik.values.time_period} onChange={(e) => formik.setFieldValue("time_period",e.value)} options={weekTimePeriod} optionLabel="name"
                            filter placeholder={t('ServiceTaskDetail.SelectRegularity')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>}
                        <div className="flex justify-content-center mb-2 mt-2">
                            <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Common.Email')}:</label>
                            <InputSwitch checked={formik.values.email} onChange={(e) => formik.setFieldValue("email",e.value)} />
                        </div>
                        <div className="flex justify-content-center">
                            <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Common.SMS')}:</label>
                            <InputSwitch checked={formik.values.sms} onChange={(e) => formik.setFieldValue("sms",e.value)} />
                        </div>
                        </div>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
                </AccordionTab>
            </Accordion>
            </div>
        </div>
        </form>
            </>
            );
} 
